module.exports = __webpack_public_path__ + "img/icone-gray.954f9a5e.png";